<div class="bg-[#2F4157] h-full overflow-auto w-[213px] pl-4 rounded-e-2xl">
    <div class="flex flex-col">
        <div class="bg-white">
            <div [ngClass]="{
                        '!rounded-br-2xl': activeIndex === 0,
            }" class="flex items-center gap-2 text-white text-lg font-semibold h-[76px] bg-[#2F4157] cursor-pointer"
                routerLink="admin/dashboard">
                <img class="w-24 h-15" src="/images/logo-red1.svg" alt="sidebar-logo">

            </div>
        </div>
        <!-- <ng-container *ngFor="let link of links; let i = index">
            <div class="bg-gradient-to-r from-[#2F4157] to-white rounded-s-3xl">
           
                <a [ngClass]="{
                            '!rounded-br-2xl': beforeActiveIndex === i,
                            '!rounded-tr-2xl': afterActiveIndex === i,
                            'bg-[#fff] !text-[#347fc4] active': activeIndex === i
                    }"
                    [routerLink]="link.path"
                    (click)="getCurrentIndex(i)"
                    class="flex bg-[#2F4157] items-center gap-2 pl-4 py-3 rounded-s-3xl text-white">
                    <img *ngIf="activeIndex != i" class="w-[18px] h-[18px]" src="{{link.icon}}" alt="">
                    <img *ngIf="activeIndex == i" class="w-[18px] h-[18px]" src="{{link.iconActive}}" alt="">
                    <span class="text-xs">{{ link.label}}</span>
                </a>
            </div>
        </ng-container> -->
        <ng-container *ngFor="let link of links; let i = index">
            <div class="bg-gradient-to-r from-[#2F4157] to-white rounded-s-3xl">
                <a [routerLink]="link.path" [ngClass]="{
                    'bg-white !text-[#347fc4] active': activeIndex === i,
                    '!rounded-br-2xl': beforeActiveIndex === i,
                    '!rounded-tr-2xl': afterActiveIndex === i
                }" class="flex bg-[#2F4157] items-center gap-2 pl-4 py-3 rounded-s-3xl text-white">
                    <img *ngIf="activeIndex !== i" [src]="link.icon" alt="non-active" class="w-[18px] h-[18px]" />
                    <img *ngIf="activeIndex === i" [src]="link.iconActive" alt="active" class="w-[18px] h-[18px]" />
                    <span class="text-xs">{{ link.label }}</span>
                </a>
            </div>
        </ng-container>
        <div class="bg-gradient-to-r from-[#2F4157] to-white">
            <div [ngClass]="{
                        '!rounded-tr-2xl': links.length === afterActiveIndex,
            }" class="bg-[#2F4157] flex items-center justify-center py-4">
                <a (click)="logout()"
                    class="px-4 cursor-pointer flex items-center justify-center gap-2 bg-white text-xs text-[#347fc4] font-semibold py-1 max-w-max rounded-full">
                    <img src="./images/sidebar/logout.svg" alt="logout">
                    Logout
                </a>
            </div>
        </div>
    </div>
</div>